import * as React from "react";
import { RecentlyViewedProducts as RecentlyViewedProducts$1 } from "@grandvisionhq/products";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachSiteLogos } from "../../../../hooks/hooks/use-bloomreach-site-logos.js";
import { useBloomreachPageName } from "../../../../hooks/hooks/use-bloomreach-page-name.js";
const CmsRecentlyViewedProducts = () => {
  const siteLogos = useBloomreachSiteLogos();
  const pageName = useBloomreachPageName();
  return /* @__PURE__ */ React.createElement(
    RecentlyViewedProducts$1,
    {
      reimbursableLogos: {
        default: siteLogos.reimbursable,
        alternative: siteLogos.reimbursableAlternative
      },
      renderLocation: pageName
    }
  );
};
const RecentlyViewedProducts = compose(
  withBreakpointVisibility,
  withAnchor
)(CmsRecentlyViewedProducts);
export {
  CmsRecentlyViewedProducts,
  RecentlyViewedProducts as default
};
//# sourceMappingURL=RecentlyViewedProducts.js.map
